<template>
  <v-card tile flat class="align-center theme-background"
          @click="handleTimeOutClick"
          :disabled="gamefinished || !canAsk"
          v-hotkey="keymap">

    <v-card-actions class="btn-border theme-highborder">
      <v-btn text class="timeout-sign theme-title theme-background"
             :disabled="gamefinished || !canAsk">T</v-btn>
      <v-spacer></v-spacer>
      <div class="dot-holder">
        <v-chip v-for="timeOut in team.timeOuts"
                :id="'team_'+team.team_id+'_timeout_'+timeOut.id"
                :key="timeOut.id"
                :color="getDotColor(timeOut)"
                :style="getDotStyle(timeOut)"
                class="dot theme-background"></v-chip>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import { hotkeys } from '@/plugins/hotkeys';
import eventBus from '@/eventBus';
import CONSTANTS from '@/constants';
import { mapGetters, mapActions } from 'vuex';

import busListeners from "@/mixins/busListeners";

export default {
    mixins: [busListeners],
  name: "TimeOut",
  props: {
    team: Object,
    gamefinished: Boolean,
    hotkeys: Boolean,
  },
  computed: {
    ...mapGetters('game', ['canTeamAskTimeOut']),

    canAsk() {
      if (this.gamefinished) return false;
      return this.canTeamAskTimeOut(this.team.team_id);
    },

    keymap: function() {
      let self = this;
      return {
        [hotkeys['timeout']]: self.hotkeys ? this.handleTimeOutClick : '',
      }
    },
  },
  methods: {
    // JAVÍTÁS: checkTimeOutRules helyett recalculateTimeOuts-t importálunk
    ...mapActions('game', ['askTimeOut', 'recalculateTimeOuts']),

    handleTimeOutClick() {
      if (this.canAsk) {
        this.askTimeOut({ teamId: this.team.team_id });
      }
    },

    // 1. Háttérszín meghatározása
    getDotColor(timeOut) {
      // Ha elveszett -> TELI PIROS
      if (timeOut.lost) {
        return '#ff0000 !important';
      }
      // Ha kikérték (de nem lost) -> TELI ZÖLD
      if (timeOut.used) {
        return '#23C373 !important';
      }
      // Ha még szabad -> ÜRES (csak a keret látszik majd)
      return '';
    },

    // 2. Keretszín (stílus) meghatározása
    getDotStyle(timeOut) {
      // Ha elveszett, a keretnek is PIROSNAK kell lennie (felülírja a CSS zöldjét)
      if (timeOut.lost) {
        return { borderColor: '#ff0000 !important' };
      }
      // Minden más esetben (teli zöld vagy üres zöld) marad az alap CSS zöld keret
      return {};
    }
  },
  created() {
    const self = this;
    // Percenként újraszámoljuk az időkéréseket (így az 55. percnél automatikusan frissül)
    this.$busOn(CONSTANTS.EVENTS.CLOCK.MINUTECHANGED, function (minute) {
      // Elég, ha csak az egyik csapat komponense hívja meg (pl. Team A / ID 1),
      // mert a store-ban mindkét csapatra lefut a számítás egyszerre.
      if (self.team.team_id === 1) {
        self.recalculateTimeOuts();
      }
    });
  }
}
</script>

<style scoped>
.dot {
  /* Alapértelmezett keret: ZÖLD. Ez adja az "Üres Zöld" és "Teli Zöld" keretét is. */
  border: 1px solid #23C373 !important;
  max-height: 8px;
  max-width: 8px;
  padding: 3px;
  margin: 2px;
}
.timeout-sign {
  font-size: 22px !important;
  text-align: center;
  min-width: 48px !important;
  height: 30px !important;
  padding: 0 !important;
}
.btn-border {
  border-style: solid;
  border-width: 1px;
  padding: 1px 4px;
}
.dot-holder {
  display: grid;
}
.v-btn--contained {
  box-shadow: none;
}
</style>
